import React from 'react';
import Select from '../ui/Select';
import { PROJECT_TYPE_FILTERS } from '../../domain/projects';

function ProjectTypeFilter({ selectedType, onTypeChange }) {
  return (
    <Select
      label="Filtrar por tipo de projeto"
      value={selectedType}
      options={PROJECT_TYPE_FILTERS}
      onChange={onTypeChange}
    />
  );
}

export default ProjectTypeFilter;
